module.exports = __webpack_public_path__ + "static/media/stripe.8fc6a20d.gif";